import { BlockToComponentMap } from 'app/features/shared/blocks'
import { LargeGroupAdBlockType, LargeGroupAdComponent } from './large-group-ad-block'
import { StandardGroupAdBlockType, StandardGroupAdComponent } from './standard-group-ad-block'
import { CarouselGroupAdBlockType, CarouselGroupAdComponent } from './carousel-group-ad-block'

export const getGroupAdBlockMappings = (): BlockToComponentMap => ({
  [LargeGroupAdBlockType]: { Component: LargeGroupAdComponent },
  [StandardGroupAdBlockType]: { Component: StandardGroupAdComponent },
  [CarouselGroupAdBlockType]: { Component: CarouselGroupAdComponent },
})
